import { observer } from 'mobx-react-lite';

import { IconStatusIndicator } from '@components/icons/status-indicator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { Color } from '@styles/theme';
import { match } from '@utils/match';

import { useStore } from 'models/Provider';

export const ApplicationStatusIndicator = observer(({ status }: { status: string }) => {
  const { t } = useStore();
  const color = match(status, colorMap);

  return (
    <Stack space={0} orientation="horizontal" align="center">
      <IconStatusIndicator color={color} />
      <Text font="regular14" text={t('applicants.status.' + status)} color={color} />
    </Stack>
  );
});

const colorMap: Record<string, Color> = {
  hired: 'green200',
  rejected: 'red100',
  retracted: 'orange100',
  active: 'blue100',
  '': 'blue100',
};
